"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Yoda_1 = require("../Yoda");
var BaseModel_1 = require("./BaseModel");
var Release_1 = require("./Release");
var User_1 = require("./User");
/** Class representing a change. */
var Change = /** @class */function (_super) {
  __extends(Change, _super);
  function Change(properties) {
    var _this = _super.call(this, {}) || this;
    _this._id = properties._id;
    _this.slug = properties.slug;
    _this.type = properties.type;
    _this.project_id = properties.project_id;
    _this.title = properties.release_notes.title;
    _this.description = properties.release_notes.description;
    _this.image = properties.release_notes.image ? "".concat(Yoda_1.default.API_END_POINT, "/changes/").concat(properties._id, "/releaseImage") : null;
    if (properties.release && !properties.release._id && properties.release.length > 0) {
      _this.release = new Release_1.default({
        _id: properties.release
      });
    }
    if (properties.assignee) _this.assignee = new User_1.default(properties.assignee);
    return _this;
  }
  Change.prototype.localizedTitle = function (lang) {
    if (!this.title) return null;
    return lang in this.title ? this.title[lang] : this.title[Object.keys(this.title)[0]];
  };
  Change.prototype.localizedDescription = function (lang) {
    if (!this.description) return null;
    return lang in this.description ? this.description[lang] : this.description[Object.keys(this.description)[0]];
  };
  Change.prototype.isFeature = function () {
    return this.type === Change.TYPE_FEATURE;
  };
  Change.prototype.isBugFix = function () {
    return this.type === Change.TYPE_FIX;
  };
  Change.prototype.slugName = function () {
    if (this.isFeature()) return "F".concat(this.slug);
    if (this.isBugFix()) return "B".concat(this.slug);
    return "C".concat(this.slug);
  };
  /**
   * Get the list of possible changes types
   * @return {String[]}
   */
  Change.types = function () {
    return [Change.TYPE_FEATURE, Change.TYPE_FIX, Change.TYPE_REFACTOR, Change.TYPE_UI, Change.TYPE_I18N, Change.TYPE_TEST, Change.TYPE_DOC, Change.TYPE_LINT, Change.TYPE_CHORE, Change.TYPE_BUILD, Change.TYPE_DEPS, Change.TYPE_RELEASE, Change.TYPE_IGNORED];
  };
  Change.TYPE_FEATURE = 'feature';
  Change.TYPE_FIX = 'fix';
  Change.TYPE_REFACTOR = 'refactor';
  Change.TYPE_UI = 'ui';
  Change.TYPE_I18N = 'i18n';
  Change.TYPE_TEST = 'test';
  Change.TYPE_DOC = 'doc';
  Change.TYPE_LINT = 'lint';
  Change.TYPE_CHORE = 'chore';
  Change.TYPE_BUILD = 'build';
  Change.TYPE_DEPS = 'dependencies';
  Change.TYPE_RELEASE = 'release';
  Change.TYPE_IGNORED = 'ignored';
  return Change;
}(BaseModel_1.default);
exports.default = Change;